import { supabase } from "../lib/api";

export const getUserSession = async () => {
  return await supabase.auth.getSession().then(({ data: { session } }) => session);
};
